var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13313_809279",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13313_809279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 21.9004C11.8833 21.9004 11.775 21.8921 11.675 21.8754C11.575 21.8587 11.475 21.8337 11.375 21.8004C9.125 21.0504 7.33333 19.6629 6 17.6379C4.66667 15.6129 4 13.4337 4 11.1004V6.37539C4 5.95872 4.12083 5.58372 4.3625 5.25039C4.60417 4.91706 4.91667 4.67539 5.3 4.52539L11.3 2.27539C11.5333 2.19206 11.7667 2.15039 12 2.15039C12.2333 2.15039 12.4667 2.19206 12.7 2.27539L18.7 4.52539C19.0833 4.67539 19.3958 4.91706 19.6375 5.25039C19.8792 5.58372 20 5.95872 20 6.37539V11.1004C20 13.4337 19.3333 15.6129 18 17.6379C16.6667 19.6629 14.875 21.0504 12.625 21.8004C12.525 21.8337 12.425 21.8587 12.325 21.8754C12.225 21.8921 12.1167 21.9004 12 21.9004ZM12 19.9004C13.7333 19.3504 15.1667 18.2504 16.3 16.6004C17.4333 14.9504 18 13.1171 18 11.1004V6.37539L12 4.12539L6 6.37539V11.1004C6 13.1171 6.56667 14.9504 7.7 16.6004C8.83333 18.2504 10.2667 19.3504 12 19.9004Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.b68efbaf4d59ce6e4ca9c3d1343f4cf6.svg";
export { ForwardRef as ReactComponent };